import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refresh: false,
    policyList:[]
};

export const policyRefreshSlice = createSlice({
    name: 'policyRefresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            state.refresh = action.payload.refresh;
        },
        setPolicyList: (state, action) => {
            state.policyList = action.payload;
        },
      setAllPolicyListArray: (state, action) => {
        return { ...state, ...action.payload };
       },
    },
});

export const { setRefresh, setPolicyList,setAllPolicyListArray } = policyRefreshSlice.actions;
export default policyRefreshSlice.reducer;
